import React, { Component } from 'react';
import axios from 'axios';
import DataBlock from '../DataBlock/Desktop';
import DataDisplay from '../DataDisplay/Desktop';
import FuelPrices from '../FuelPrices';
import Metar from '../Metar/Desktop';
import AwosHeader from '../AwosHeader/Desktop';
import AwosMessage from '../AwosMessage';
import SuggestedRunway from '../SuggestedRunway';
import Hammer from 'react-hammerjs';
import './App.css';
import 'event-source-polyfill';

class App extends Component {
  componentDidMount () {
    this.fetchData();
    setInterval(this.fetchData, +this.props.pollInterval);
  }
  constructor() {
    super();

    this.numSections = 4;
    this.sectionWidth = 110;

    this.state = {
      awos: null,
      currentSection: 0,
      fuel: null
    };

    this.fetchData = this.fetchData.bind(this);
    this.swipe = this.swipe.bind(this);
  }
  fetchData() {
    axios.get('api/current-conditions')
    .then(res => {
      let newState = res.data;

      delete newState.awos.type;
      delete newState.fuel.type;

      this.setState(newState);
    });
  }
  render() {
    const slidePosition = `translateX(-${this.state.currentSection * this.sectionWidth}%)`;
    let slideIndicators = [];

    for (let i = 0; i < this.numSections; i++) {
      slideIndicators.push(<li key={i} className={ i === this.state.currentSection  ? 'active-section' : '' } />)
    }

    if(!this.state.awos || !this.state.awos.updated) {
      return (
        <div className="loading">LOADING</div>
      );
    }
    return (
      <Hammer onSwipe={this.swipe}>
        <div className="awos-container">
          <AwosHeader airport={this.state.awos.airport} wind={this.state.awos.wind} />
          <div className="section-container">
            <div className="sections-slide" style={{ transform: slidePosition  }}>
              <div className="section">
                <div className="awos-details glow-box">
                  <DataBlock label="Pressure">
                    <DataDisplay label="Altimeter" data={this.state.awos.pressure.altimeter} />
                    <DataDisplay label="D/A" data={this.state.awos.pressure.densityAltitude} />
                  </DataBlock>
                  <DataBlock label="Winds">
                    <DataDisplay label="Speed" data={this.state.awos.wind.speed} />
                    <DataDisplay label="Direction" data={this.state.awos.wind.direction} />
                    <DataDisplay label="Gust" data={this.state.awos.wind.gust} />
                    <DataDisplay label="Variable" data={this.state.awos.wind.variable} />
                  </DataBlock>
                  <DataBlock label="Temperature">
                    <DataDisplay label="Air Temp" data={this.state.awos.temperature.air} />
                    <DataDisplay label="Dew Point" data={this.state.awos.temperature.dewPoint} />
                    <DataDisplay label="RH" data={this.state.awos.temperature.humidity} />
                  </DataBlock>
                  <DataBlock label="Precipitation">
                    <DataDisplay label="Precip" data={this.state.awos.rainfall} />
                  </DataBlock>
                  <DataBlock label="Visibility">
                    <DataDisplay label="Vis" data={this.state.awos.visibility} />
                  </DataBlock>
                  <DataBlock label="Present Weather">
                    <DataDisplay label="Weather" data={this.state.awos.weather} />
                  </DataBlock>
                  <DataBlock label="Clouds">
                    <DataDisplay label="Clouds" data={this.state.awos.clouds} />
                  </DataBlock>
                </div>
                <Metar data={this.state.awos.metar} />
              </div>
              <div className="section">
                <SuggestedRunway runwayA="36" runwayB="18"
                                 wind={this.state.awos.wind.direction.value}
                                 historicWind={this.state.awos.wind.lastTwoMin.direction.value} />
              </div>
              <div className="section">
                <FuelPrices data={this.state.fuel.data} lastUpdate={this.state.fuel.updated} />
              </div>
              <div className="section">
                <AwosMessage phone="(405) 283-9848"/>
              </div>
            </div></div>
          <div className="section-indicator">
            <ul>
              { slideIndicators }
            </ul>
          </div>
        </div>
      </Hammer>
    );
  }
  swipe(e) {
    const direction = e.direction === 2 ? 1 : -1;
    const newSection = this.state.currentSection + direction;

    if(window.innerWidth < 960 && newSection >= 0 && newSection < this.numSections) {
      this.setState( {
        currentSection: newSection
      });
    }
  }
}

export default App;



/** WEBPACK FOOTER **
 ** ./src/App/App.js
 **/